<!--
 * @Author:
 * @Description: 文档解析进度
-->
<template>
  <el-card class="h-full overflow-auto" :body-style="{ padding: '20px', height: '100%' }">
    <el-row>
      <el-input
        class="w-200px ml-10px mr-10px"
        v-model="search.taskName"
        placeholder="任务名称"
        size="small"
        clearable
      />
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        class="w-200px ml-10px mr-10px"
        v-model="search.classId"
        placeholder="请选择实体"
        size="small"
        filterable
        clearable
      >
        <el-option
          v-for="item in classTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        class="w-200px ml-10px mr-10px"
        v-model="search.filter"
        placeholder="模型名称"
        size="small"
        clearable
      />
      <el-select
        class="w-200px ml-10px mr-10px"
        v-model="search.runStatus"
        placeholder="状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in statusList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="searchList">搜索</el-button>
      <el-button type="danger" :disabled="!$hasAccess('delete')" @click="toDelete(ids)"
        >删除</el-button
      >
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      :highlight-current-row="true"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      ref="table"
      row-key="id"
      stripe
      border
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        label="任务名称"
        prop="documentParseTaskName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="文档编码"
        prop="documentCode"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="参照标准" prop="standardName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="解析实体"
        prop="className"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="解析属性"
        prop="classAttributeName"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="状态" prop="runStatusName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="解析结果"
        prop="result"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="创建时间" prop="createdTime" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="修改时间"
        prop="lastModifiedTime"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button size="mini">查看</el-button>
          <el-button size="mini" @click="toDelete([scope.row.id])">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="float-right my-20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import documentConfigService from '@/services/documentConfigService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'documentParseProgress',
  components: {
    selectStandardId,
  },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      search: {
        taskName: '',
        classId: '',
        filter: '',
        runStatus: '',
      },
      classTypeList: [],
      statusList: [
        { id: '0', name: '进行中' },
        { id: '1', name: '已完成' },
        { id: '2', name: '失败' },
      ],
      ids: [],
      selectionList: [],
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.getClassTypeList()
        this.searchList()
      }
    },
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  created() {
    this.getClassTypeList()
    this.searchList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取实体列表
    async getClassTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    // 表格多选
    selectionChange(val) {
      this.selectionList = val
      this.ids = val.map((item) => {
        return item.id
      })
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableList()
    },
    // 获取表格数据
    async getTableList() {
      this.tableLoading = true
      const res = await documentConfigService.getDocumentRelation({
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        standardId: this.standardId,
        ...this.search,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getTableList()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.getTableList()
    },
    // 排序
    sortChange() {},
    // 删除
    async toDelete(ids) {
      if (!ids.length) {
        this.$message.info('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        // const res = await ModelParsingTaskService.deleteModelObjectRelation(ids)
        // if (res) {
        //   this.$message.success('删除成功')
        //   this.searchList()
        // }
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
